export function isGameLocation() {
  return location.pathname.startsWith('/game')
}
export function isLrLocation() {
  return location.pathname.startsWith('/lr')
}
